import { render, staticRenderFns } from "./ProxySelector.vue?vue&type=template&id=6167aaf3&"
import script from "./ProxySelector.vue?vue&type=script&lang=js&"
export * from "./ProxySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports